import BankAccountManager from "./BankAccountManager";

const PNBankAccountManager = () => {
  return <BankAccountManager routePath="/pn-bank-account" />
}

export default PNBankAccountManager;